import React, { Component, ChangeEvent } from "react";
import "./LoginPage.css";
import { authContext } from "./AdalConfig";
import BackgroundCarousel from "./BackgroundCarousel";
import { UserLoginTriggerandTokenSet } from '../Components/ApiSevices/AuthApis';
import { privacyNotice } from '../Components/Pages/ApiCommonService'
import { Link } from "react-router-dom";
import App from '../App';
import { Alert, Snackbar, Box } from '@mui/material';
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import ForgotPassword from "./ForgotPassword";
import { expTokenProcessAndGenerate } from "../Components/ApiSevices/AuthApis";
import AppFooter from "../Components/Header/Footer";
import LoginFooter from "../LoginConfig/LoginFooter";

interface Props {
    sessionFlag: any;
}

interface State {
    username: string;
    password: string;
    termsAccepted: boolean;
    error: string;
    loading: boolean;
    snackbarOpen: boolean;
    snackbarMessage: any;
    snackbarSeverity: any;
    token: string | null;
}

class LoginPage extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            username: "",
            password: "",
            termsAccepted: false,
            loading: false,
            error: "",
            snackbarOpen: false,
            snackbarMessage: '',
            snackbarSeverity: 'success',
            token: null
        };
    }

    showSnackbar = (message: string, severity: "success" | "error" | "info" | "warning") => {
        this.setState({ snackbarOpen: true, snackbarMessage: message, snackbarSeverity: severity });
    };

    handleCloseSnackbar = () => {
        this.setState({ snackbarOpen: false });
    };

    handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        this.setState({ [name]: type === "checkbox" ? checked : value } as any);
    };

    handleCustomUserLogin = async () => {
        const { username, password, termsAccepted } = this.state;
        if (!termsAccepted) {
            this.setState({ error: "You must accept the terms." });
            return;
        }
        this.setState({ loading: true, error: "" });
        try {
            const res = await UserLoginTriggerandTokenSet(username, password);
            if (res) {
                sessionStorage.setItem("token", res);
                const getToken = await expTokenProcessAndGenerate(res);
                if (getToken) {
                    this.setState({ token: getToken });
                } else {
                    this.setState({ error: "Token processing failed." });
                }
            } else {
                this.setState({ error: "Invalid credentials" });
            }
        } catch {
            this.setState({ error: "Login error occurred." });
        } finally {
            this.setState({ loading: false });
        }
    };

    handleMicrosoftLogin = () => {
        authContext.login();
    };

    render() {
        const { username, password, termsAccepted, error, loading, snackbarOpen, snackbarMessage, snackbarSeverity, token } = this.state;
        const { sessionFlag } = this.props;
        
        if (sessionFlag === "true") return <p>Loading...</p>;


        if (token) {
            return <App token={token} isAuthenticated={true} isLoading={false} />;
        }  
        if(window.location.pathname === '/forgotpassword'){
            return <ForgotPassword />
        }


        return (
            <>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}

                <div className="login-container">
                    <BackgroundCarousel />
                    <div className="overlay">
                        <div className="login-box">
                            <img style={{ border: "1px solid black" }} src="/exdionedge.jpg" className="logo" alt="Exdionedge" />
                            <input
                                type="text"
                                name="username"
                                placeholder="Username"
                                value={username}
                                onChange={this.handleChange}
                            />
                            <input
                                type="password"
                                name="password"
                                placeholder="Password"
                                value={password}
                                onChange={this.handleChange}
                            />
                            {error && <p style={{ color: "red", fontSize:"12px", marginBottom:"5px" }}>{error}</p>}
                            <label>
                                <input
                                    type="checkbox"
                                    name="termsAccepted"
                                    checked={termsAccepted}
                                    onChange={this.handleChange}
                                />
                                I have read the <a
                                    href="/PrivacyPolicy.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    >
                                    Privacy Policy
                                    </a>
                                and agree to the terms and conditions.
                            </label>
                            <button onClick={this.handleCustomUserLogin} disabled={!termsAccepted}>Submit</button>
                            <button className="microsoft-button" onClick={this.handleMicrosoftLogin} disabled={!termsAccepted}>
                                <img src="https://img.icons8.com/color/16/000000/microsoft.png" alt="ms" />
                                Sign in
                            </button>
                            <Link to={"#"} onClick={() => window.location.href  = "/forgotpassword"}><span className="forget-psd-style">Forgot Password?</span></Link>
                            <div className="footer-banner">
                                <img src="/Banner.png" alt="Banner" width="100%" />
                            </div>
                        </div>
                    </div>
                </div>
                <LoginFooter/>
            </>
        );
    }
}

export default LoginPage;
